export interface ReplayTickFrame {
  tick: number;
  roundNumber: number;
}

export interface ReplayTickSample {
  frameIndex: number;
  nextFrameIndex: number;
  alpha: number;
}

export function resolveReplayTickSample(
  frames: ReplayTickFrame[],
  targetTick: number,
): ReplayTickSample {
  if (frames.length === 0) {
    return { frameIndex: 0, nextFrameIndex: 0, alpha: 0 };
  }

  const clampedTick = Math.max(frames[0].tick, Math.min(frames.at(-1)!.tick, targetTick));
  let low = 0;
  let high = frames.length - 1;
  while (low < high) {
    const middle = Math.ceil((low + high) / 2);
    if (frames[middle].tick <= clampedTick) low = middle;
    else high = middle - 1;
  }

  const frameIndex = low;
  const nextFrameIndex = Math.min(frameIndex + 1, frames.length - 1);
  const current = frames[frameIndex];
  const next = frames[nextFrameIndex];
  const tickSpan = next.tick - current.tick;
  const alpha = (
    nextFrameIndex !== frameIndex
    && next.roundNumber === current.roundNumber
    && tickSpan > 0
  )
    ? Math.max(0, Math.min(1, (clampedTick - current.tick) / tickSpan))
    : 0;

  return { frameIndex, nextFrameIndex, alpha };
}

export function advanceReplayTick(
  currentTick: number,
  elapsedMilliseconds: number,
  tickRate: number,
  playbackSpeed: number,
) {
  if (
    !Number.isFinite(currentTick)
    || !Number.isFinite(elapsedMilliseconds)
    || elapsedMilliseconds <= 0
    || !Number.isFinite(tickRate)
    || tickRate <= 0
    || !Number.isFinite(playbackSpeed)
    || playbackSpeed <= 0
  ) return currentTick;

  return currentTick + elapsedMilliseconds / 1000 * tickRate * playbackSpeed;
}
